import heroImg from "../assets/images/illustration-working.svg";
import { motion, MotionConfig } from "motion/react";

function HeroSection() {
	return (
		<div className="hero">
			<MotionConfig
				transition={{
					duration: 0.45,
					ease: "easeOut",
				}}
			>
				<div className="hero-text">
					<motion.h1
						initial={{ opacity: 0, y: -20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
					>
						More than just shorter links
					</motion.h1>

					<motion.p
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 14 }}
						viewport={{ once: true }}
					>
						Build your brand’s recognition and get detailed insights on how your
						links are performing.
					</motion.p>

					<motion.button
						className="start-btn"
						initial={{ opacity: 0, y: 16 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
					>
						Get Started
					</motion.button>
				</div>

				<motion.img
					src={heroImg}
					alt="hero"
					initial={{ opacity: 0, x: 120 }}
					whileInView={{ opacity: 1, x: 0 }}
					viewport={{ once: true }}
					// transition={{ type: "spring", duration: 2 }}
					// transition={{ease: "easeOut", duration: 0.7}}
				/>
			</MotionConfig>
		</div>
	);
}

export default HeroSection;
